export default __webpack_public_path__ + "static/media/android.db19cc9e.svg";